
import Helper from "./Helper";

class LottieSwiper {
  constructor() {
    this.lotties = document.querySelectorAll("lottie-player");
    this.lottiesArray = Array.prototype.slice.call(this.lotties);
    this.classIn = "is-in-viewport";
    this.classOut = "is-not-in-viewport";
    this.wasActiveMap = new WeakMap();

    if (this.lotties && this.lotties.length !== 0) {
      this.registerObserver();
      this.registerSlideObserver();
    }
  }

  registerObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const container = entry.target;
        const lottie = container.matches("lottie-player")
          ? container
          : container.querySelector("lottie-player");

        if (!lottie) {
          return;
        }

        const slide = container.closest(".swiper-slide");
        const isActiveSlide =
          !slide ||
          slide.classList.contains("swiper-slide-active");

        if (entry.isIntersecting && isActiveSlide) {
          Helper.addClass(container, this.classIn);
          Helper.removeClass(container, this.classOut);
          this.playWhenReady(lottie);
        } else {
          Helper.removeClass(container, this.classIn);
          Helper.addClass(container, this.classOut);
          if (typeof lottie.stop === "function") {
            lottie.stop();
          }
        }
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    });

    this.lottiesArray.forEach((item) => {
      const target = this.getObserverTarget(item);
      if (target) {
        observer.observe(target);
      }
    });
  }

  registerSlideObserver() {
    const wrappers = document.querySelectorAll(".swiper-wrapper");

    wrappers.forEach((wrapper) => {
      this.syncSlidesInWrapper(wrapper);

      const classObserver = new MutationObserver(() => {
        this.syncSlidesInWrapper(wrapper);
      });

      classObserver.observe(wrapper, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class"]
      });
    });
  }

  syncSlidesInWrapper(wrapper) {
    const slides = wrapper.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const isActiveSlide = slide.classList.contains("swiper-slide-active");
      const inViewport = this.isElementInViewport(slide);
      const lotties = slide.querySelectorAll("lottie-player");

      lotties.forEach((lottie) => {
        const wasActive = this.wasActiveMap.get(lottie) === true;

        if (isActiveSlide && inViewport) {
          lottie.loop = false;
          lottie.removeEventListener("complete", lottie._loopHandler);
          lottie._loopHandler = null;
          if (!wasActive) {
            lottie.stop && lottie.stop();
            this.playWhenReady(lottie);
          }
        } else {
          lottie.loop = false;
          lottie.removeEventListener("complete", lottie._loopHandler);
          lottie._loopHandler = null;
          if (wasActive && typeof lottie.stop === "function") {
            lottie.stop();
          }
        }
        this.wasActiveMap.set(lottie, isActiveSlide && inViewport);
      });
    });
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  playWhenReady(lottie) {
    if (
      typeof customElements !== "undefined" &&
      typeof customElements.whenDefined === "function" &&
      !customElements.get("lottie-player")
    ) {
      customElements.whenDefined("lottie-player").then(() => {
        this.playWhenReady(lottie);
      });
      return;
    }

    if (typeof lottie.play !== "function") {
      return;
    }

    if (typeof lottie.getLottie === "function" && lottie.getLottie()) {
      if (typeof lottie.stop === "function") {
        lottie.stop();
      }
      lottie.play();
      return;
    }

    const playOnReady = () => {
      lottie.play();
    };

    lottie.addEventListener("ready", playOnReady, { once: true });
    lottie.addEventListener("load", playOnReady, { once: true });
  }

  getObserverTarget(item) {
    const parent = item.closest(".swiper-slide");
    if (parent) {
      return parent.querySelector(".lc-swiper-slide__lottie-container");
    }
    return item;
  }

}

export default LottieSwiper;

